import template from './leave_taken_comparison_between_departments_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class LeaveTakenComparisonBetweenDepartmentsHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class LeaveTakenComparisonBetweenDepartmentsHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new LeaveTakenComparisonBetweenDepartmentsHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'LeaveTakenComparisonBetweenDepartmentsHelp',
	dialog_class: LeaveTakenComparisonBetweenDepartmentsHelpPage,
	template: template,
	template_filename: 'translation/dialogs/leave_taken_comparison_between_departments_help',
	provider: 'ps'
};
